import { AppShell } from '../components/AppShell';

interface Props {
  title: string;
  subtitle: string;
  /** Mô tả tóm tắt tính năng — hiển thị trong empty state. */
  description?: string;
}

/**
 * Trang stub cho các mục prototype chưa có backend/UI.
 * Reuse cho: congnoda, congtacqt, vaynh, hopnhat.
 */
export function PlaceholderPage({ title, subtitle, description }: Props) {
  return (
    <AppShell title={title} subtitle={subtitle}>
      <div style={{
        background: '#fff',
        border: '1px solid #e4e7ec',
        borderRadius: 12,
        padding: '48px 32px',
        textAlign: 'center',
        maxWidth: 640,
        margin: '20px auto',
        boxShadow: '0 1px 3px rgba(15,23,42,.04)',
      }}>
        <div style={{
          width: 64, height: 64, borderRadius: '50%',
          background: 'linear-gradient(135deg,#eff6ff,#dbeafe)',
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          marginBottom: 16,
        }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v6l4 2" />
          </svg>
        </div>
        <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800, color: '#172033' }}>
          {title} — đang phát triển
        </h2>
        <p style={{ margin: '8px 0 0', fontSize: 13, color: '#64748b', lineHeight: 1.6 }}>
          {description ?? 'Tính năng này đã có trong roadmap nhưng chưa build. Menu đã sẵn sàng theo prototype để khi backend + UI hoàn thành, chỉ cần swap component.'}
        </p>
        <div style={{
          marginTop: 20, display: 'inline-flex', gap: 6, padding: '6px 12px',
          background: '#fef3c7', color: '#a16207',
          fontSize: 11, fontWeight: 600, borderRadius: 9999,
        }}>
          Trạng thái: TODO
        </div>
      </div>
    </AppShell>
  );
}
